var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"block",class:{ active: _vm.isActiveLink },attrs:{"to":_vm.link}},[_c('div',{staticClass:"inline-block clickable px-2 py-1"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }